import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, Fragment, useCallback } from "react";
import { useParams } from "react-router-dom";
import Loading from "../components/Loading";
import TableDocuments from "../components/TableDocuments";
import ModalCategoryForm from "../components/ModalCategoryForm";
import ModalDocumentForm from "../components/ModalDocumentForm";
import api from "../services/api";
import auth from "../services/auth";
import onDate from "../utils/Date";
import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/system";

const stylesSx = {
  paper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",

    p: 2,
  },
  mainPaper: {
    minHeight: "100vh",
    p: 2,
  },
  gridTitle: {
    mb: 2,
  },
  paperCategories: {
    p: 2,
    height: "20vh",
    overflow: "auto",
  },
  gridInfos: {
    minHeight: "100vh",
  },
  optionsTitle: {
    flex: 1,
  },
  paperDocuments: {
    height: "70vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    p: 2,
  },
  noMachBox: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default function UserProfile() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [documents, setDocuments] = useState([]);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [creatorId, setCreatorId] = useState(Number);
  const [state, setState] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  const onRequest = useCallback(async () => {
    await api
      .get(`users/${id}`, { headers: auth.token() })
      .then(async (response) => {
        await setUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    await api
      .get("documents", {
        params: id ? { user_id: id /* ,category_id: */ } : {},
        headers: auth.token(),
      })
      .then(async (response) => {
        if (response.status === 200) {
          console.log(response.data.data);
          setDocuments(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
    await api.get("auth", { headers: auth.token() }).then((response) => {
      setCreatorId(response.data.id);
    });
    setLoading(false);
  }, [id]);

  useEffect(() => {
    setLoading(true);
    onRequest();
    return () => {
      setUser({});
      setDocuments([]);
    };
  }, [onRequest, state]);

  const handleDeleteCategory = (id) => {
    api
      .delete(`categories/${id}`, { headers: auth.token() })
      .then((response) => {
        if (response.status === 200) {
          setState((prev) => !prev);
        }
      })
      .then((error) => {
        console.log(error);
      });
  };

  const handleClose = async () => {
    await setOpenCategoryModal(false);
    await setOpenDocumentModal(false);
    setEditCategory(null);
  };

  const handleDeleteDocument = (id) => {
    api
      .delete(`documents/${id}`, { headers: auth.token() })
      .then((response) => {
        if (response.status === 200) {
          setState((prev) => !prev);
        }
      })
      .then((error) => {
        console.log(error);
      });
  };

  const handleEditCategory = async (category) => {
    await setEditCategory(category);
    setOpenCategoryModal(true);
  };

  const handleDownload = (id, name) => {
    api
      .get(`documents/${id}`, { headers: auth.token(), responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${name}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
  };

  return loading ? (
    <Loading />
  ) : (
    <Fragment>
      <ModalCategoryForm
        openCategoryModal={openCategoryModal}
        handleClose={handleClose}
        userId={user.id}
        setState={setState}
        category={editCategory}
        categories={user.categories}
      />
      <ModalDocumentForm
        userId={user.id}
        openDocumentModal={openDocumentModal}
        handleClose={handleClose}
        creatorId={creatorId}
        categories={user.categories}
        setState={setState}
      />
      <Paper sx={stylesSx.mainPaper}>
        <Grid container sx={stylesSx.gridTitle}>
          <Grid item xs>
            <Typography variant="h4" color="primary">
              {user.name}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" color="primary">
              {user.cpf_cnpj}
            </Typography>
          </Grid>
        </Grid>
        <Grid sx={stylesSx.gridInfos} container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <Paper elevation={3} sx={stylesSx.paper}>
              <Typography variant="h5" color="primary">
                Informações
              </Typography>
              <Typography variant="subtitle1" component="p">
                Ultima atualização:{" "}
                {user.updated_at ? onDate(user.updated_at) : "00/00/0000"}
              </Typography>
              <Typography variant="subtitle1" component="p">
                {user.email}
              </Typography>
              <Typography variant="subtitle1" component="p">
                {user.cellphone}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Paper elevation={3} sx={stylesSx.paper}>
              <Stack
                sx={{ mb: 1 }}
                spacing={1}
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
              >
                <Typography
                  sx={stylesSx.optionsTitle}
                  variant="h5"
                  color="primary"
                >
                  Categorias
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => setOpenCategoryModal(true)}
                  endIcon={<AddIcon />}
                >
                  Nova Categoria
                </Button>
              </Stack>
              <Paper sx={stylesSx.paperCategories}>
                <Grid container direction="row" spacing={1}>
                  {!user.categories ? (
                    <Grid item xs={12}>
                      Nenhuma Categoria cadastrada
                    </Grid>
                  ) : (
                    user.categories &&
                    user.categories.map((category) => (
                      <Grid key={category.id} item xs={6} md={4} lg={3}>
                        <Chip
                          color="primary"
                          label={category.name}
                          onClick={() => handleEditCategory(category)}
                          onDelete={() => handleDeleteCategory(category.id)}
                        />
                      </Grid>
                    ))
                  )}
                </Grid>
              </Paper>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} sx={stylesSx.paperDocuments}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                spacing={1}
              >
                <Typography sx={{ mb: 2 }} variant="h5" color="primary">
                  Documentos do Usuário
                </Typography>
                <Stack spacing={1} direction={{ xs: "column", sm: "row" }}>
                  <Button
                    disabled={user.categories && user.categories.length === 0}
                    variant="contained"
                    onClick={() => setOpenDocumentModal(true)}
                    endIcon={<AddIcon />}
                  >
                    Novo Documento
                  </Button>
                </Stack>
              </Stack>
              {documents.length === 0 ? (
                <Box sx={stylesSx.noMachBox}>
                  <Typography variant="h3">
                    Nenhum Documento Cadastrado
                  </Typography>
                </Box>
              ) : (
                <TableDocuments
                  handleDeleteDocument={handleDeleteDocument}
                  isUserPage={true}
                  documents={documents}
                  categories={user.categories}
                  handleDownload={handleDownload}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
}
